import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../config';

/**
 * Muestra el precio referencial en Bs. al tipo de cambio oficial del BCV
 * para usuarios en Venezuela. EXCLUSIVAMENTE INFORMATIVO.
 * CUALAPP NO opera ni cobra en VES.
 */
const BcvReferencePrice = ({ usdAmount, compact = false }) => {
  const [rate, setRate] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/exchange/bcv`).then(r => {
      if (mounted) {
        if (r.data?.rate) setRate(r.data.rate);
        else setError(true);
      }
    }).catch(() => mounted && setError(true));
    return () => { mounted = false; };
  }, []);

  if (error || rate === null) return null;
  const ves = (Number(usdAmount) * Number(rate)).toFixed(2);
  const formatted = Number(ves).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  if (compact) {
    return (
      <span data-testid="bcv-ref-compact" className="text-[10px] text-gray-500">
        ≈ Bs. {formatted}
      </span>
    );
  }
  return (
    <div data-testid="bcv-ref" className="text-[11px] text-gray-500 leading-tight mt-0.5">
      ≈ Bs. {formatted} <span className="text-gray-400">(Tipo de cambio oficial BCV)</span>
    </div>
  );
};

export default BcvReferencePrice;
